import * as Localization from "expo-localization";
import { I18n } from "i18n-js";

import EN from "./en.json";
import ML from "./ml.json";

const translations = {
  en: EN.data,
  ml: ML.data,
};

const i18n = new I18n(translations);

i18n.locale = Localization.locale;

i18n.enableFallback = true;

const translate = (data, args?) => {
  return i18n.t(data, args);
};

export default translate;
export { i18n };
